import { render, staticRenderFns } from "./Hotel.vue?vue&type=template&id=7242cbd6&scoped=true&"
import script from "./Hotel.vue?vue&type=script&lang=js&"
export * from "./Hotel.vue?vue&type=script&lang=js&"
import style0 from "./Hotel.vue?vue&type=style&index=0&id=7242cbd6&lang=less&scoped=true&"
import style1 from "./Hotel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7242cbd6",
  null
  
)

component.options.__file = "Hotel.vue"
export default component.exports